import {
  OreButton,
  OreHeading,
  OreModal,
  OreModalBox,
  OreModalBoxBody,
  OreModalBoxFooter,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { useExcelUpload } from '@/Store/ui/context/ExcelUploadContext'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { navigationRoutes } from '@/Shared/ui/routers/data/navigationRoutes'
import { useNavigate } from 'react-router-dom'

export const CancelModal = (): JSX.Element => {
  const { t } = useTranslation()

  const {
    displayCancelModal,
    setDisplayCancelModal,
    uploadForm
  } = useExcelUpload()
  const navigate = useNavigate()

  const handleExit = () => {
    uploadForm.reset()
    navigate(navigationRoutes.storeTPV)
  }

  return (
    <OreModal open={displayCancelModal} handleOnClose={() => setDisplayCancelModal(false)}>
      <OreModalBox size="medium" handleOnClose={() => setDisplayCancelModal(false)}>
        <OreModalBoxBody>
          <OreHeading size="headline-lg">
            {t(storesTranslation.excelCancelModal.title)}
          </OreHeading>
          <OreText>{t(storesTranslation.excelCancelModal.description)}</OreText>
        </OreModalBoxBody>
        <OreModalBoxFooter>
          <OreButton onClick={() => setDisplayCancelModal(false)} category="secondary">
            {t(storesTranslation.excelCancelModal.cancel_button)}
          </OreButton>
          <OreButton onClick={handleExit} size="small" category="danger">
            {t(storesTranslation.excelCancelModal.exit_button)}
          </OreButton>
        </OreModalBoxFooter>
      </OreModalBox>
    </OreModal>
  )
}
